<div class="row reviewer-row">
  <button
    appDeleteFocus
    class="delete-button delete-reviewer"
    (click)="handleDeleteReviewerButtonClick(team().id, monthData().monthNumber)"
  >
    <i class="delete-icon"></i>
  </button>
  <div class="column name">
    {{ team().reviewer.name }}
  </div>
  <div class="column">
    {{ formatNumberValueToRubles(team().reviewerReport['plan']) }}
  </div>
  <div class="column">
    <app-fact-value
      [factValue]="formatNumberValue(team().reviewerReport['fact'])"
      [published]="formatNumberValue(team().reviewerReport['releasedFact'])"
      [expected]="formatNumberValue(team().reviewerReport['waitingFact'])"
    />
  </div>
  <div class="column">
    {{ formatNumberValue(team().reviewerReport['realization']) }}%
  </div>
  @if (isAnyTeamInProduct(product())) {
    <div
      class="column actions"
      [class.collapsed-column]="!product().platforms.product.isActionsColumnOpen"
    >
      @if (product().platforms.product.isActionsColumnOpen) {
        <app-grouped-value-columns
          [columns]="[
            formatNumberValue(team().reviewerReport['views']),
            formatNumberValue(team().reviewerReport['clicks']),
            formatNumberValue(team().reviewerReport['visits']),
            formatNumberValue(team().reviewerReport['orders']),
            formatNumberValue(team().reviewerReport['requests'])
          ]"
          [widths]="actionsWidths"
        />
      }
    </div>
  }
  @if (isAnyTeamInProduct(product())) {
    <div
      class="column stats"
      [class.collapsed-column]="!product().platforms.product.isStatsColumnOpen"
    >
      @if (product().platforms.product.isStatsColumnOpen) {
        <app-grouped-value-columns
          [columns]="[
            formatNumberValue(team().reviewerReport['cpv'], 2),
            formatNumberValue(team().reviewerReport['cpc'], 2),
            formatNumberValue(team().reviewerReport['cpa'], 2),
            formatNumberValue(team().reviewerReport['cps'], 2),
            formatNumberValue(team().reviewerReport['cpz'], 2)
          ]"
          [widths]="statsWidths"
        />
      }
    </div>
  }
  @if (isAnyTeamInProduct(product())) {
    <div
      class="column results"
      [class.collapsed-column]="!product().platforms.product.isResultsColumnOpen"
    >
      @if (product().platforms.product.isResultsColumnOpen) {
        <app-grouped-value-columns
          [columns]="[
            formatNumberValue(team().reviewerReport['averageCheck']),
            (team().reviewerReport['integrationsPlan'] ?? 0) + '/' + (team().reviewerReport['integrationsFact'] ?? 0)
          ]"
          [widths]="resultsWidths"
        />
      }
    </div>
  }
</div>
